import type { ApolloLink } from '@apollo/client';
import { Apollo } from 'src/gql/generated';

export function useDisableSignatureField(): {
  disableSignatureField: (
    id: UUID,
    options: Parameters<Apollo.DisableSignatureFieldMutationHookResult[0]>[0]
  ) => Promise<ApolloLink.Result<Apollo.DisableSignatureFieldMutation>>;
} {
  const [disableSignatureField] = Apollo.useDisableSignatureFieldMutation();

  return {
    disableSignatureField: (id, options) => {
      return disableSignatureField({
        ...options,
        optimisticResponse: {
          __typename: 'Mutation',
          disableSignatureField: {
            __typename: 'SignatureField',
            deletedAt: new Date().toISOString(),
            id,
          },
        },
      });
    },
  };
}
